{
  "name": "@byted/tiktok-zti-request-hooks",
  "version": "0.1.43",
  "unpkg": true,
  "unpkgFiles": [
    "*"
  ],
  "types": "./dist/types/index.d.ts",
  "jsnext:source": "./src/index.ts",
  "main": "./dist/lib/index.js",
  "module": "./dist/es/index.js",
  "scripts": {
    "dev": "edenx dev",
    "build": "edenx build",
    "build:watch": "edenx build -w",
    "new": "edenx new",
    "upgrade": "edenx upgrade"
  },
  "dependencies": {
    "@byted/tiktok-zti-utils": "workspace:*",
    "@byted/tiktok-zti-monitor": "workspace:*",
    "@byted/tiktok-zti-call": "0.1.2",
    "@byted/tiktok-zti-crypto": "workspace:*",
    "@byted/tiktok-zti-types": "workspace:*"
  },
  "devDependencies": {
    "@byted/eslint-config-eden": "^5.0.21",
    "@edenx/module-tools": "1.48.4",
    "eslint-plugin-prettier": "~4.2.1",
    "rimraf": "~3.0.2",
    "typescript": "~5.0.4"
  },
  "publishConfig": {
    "access": "public",
    "registry": "https://bnpm.byted.org/"
  }
}
